module.exports = __webpack_public_path__ + "static/media/fog.b865486a.png";